import {useShopId} from '@aboutyou/config';
import {Log as LogBase} from '@aboutyou/mlm';
import {
  getIsDatadogInfoLogsConsentGiven,
  getIsDatadogPersonalisationConsentGiven,
} from '@aboutyou/storage';
import {useUserLoginType} from '@aboutyou/user';
import {useCallback} from 'react';
import {AuthenticationContexts} from '../AuthenticationProvider/AuthenticationContexts';
import {useLogInstanceId} from './useLogInstanceId';

export const useLoginScreenLogger = () => {
  const shopId = useShopId();
  const {id: log_instance_id} = useLogInstanceId();
  const loginType = useUserLoginType();

  const logLoginPopup = useCallback(
    ({
      event,
      context,
    }: {
      event: 'opened' | 'cancelled' | 'login-success' | 'login-fail';
      context: AuthenticationContexts;
    }) => {
      if (!getIsDatadogInfoLogsConsentGiven()) return;

      LogBase.unSampledLog('login-screen', {
        feature: 'auth',
        message: 'login-screen',
        context,
        event,
        shop_id: shopId,
        log_instance_id,
        device: `${process.env.STACK}-web`,
        loginType: getIsDatadogPersonalisationConsentGiven()
          ? loginType
          : undefined,
      });
    },
    [shopId, log_instance_id, loginType],
  );

  return logLoginPopup;
};
